import React, { useEffect, useState } from "react";
import Error from "../../../shared/components/Error";
import { withTranslation } from "react-i18next";
import ConsentToShareInformationView from "./components/ConsentToShareInformationView";

const ConsentToShareInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false);

  //   useEffect(() => {
  //     document.title =
  //       "Consent to Information - HARP - Government of Nova Scotia";
  //   }, []);

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "Consent for SNS and CRA to share my personal information - HARP- Government of Nova Scotia";
    } else {
      document.title =
        "Consentement à l'échange de mes renseignements personnels entre SNÉ et l'ARC - Allocation pour services à domicile chez les aînés - Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  return isError ? (
    <Error />
  ) : (
    <ConsentToShareInformationView setIsError={setIsError} />
  );
};

export default withTranslation("common")(ConsentToShareInformation);
